import {
  Card,
  CardContent,
  CardHeader,
  Grid,
  Typography,
  Chip,
} from '@material-ui/core';
import { Finding, SEVERITY_ORDER } from '../utils/types';
import {
  countBySeverity,
  calculateResolvedPercentage,
  getMostRecentFindingDate,
  getSeverityColor,
} from '../utils/severity';

interface SummaryCardProps {
  findings: Finding[];
}

export const SummaryCard = ({ findings }: SummaryCardProps) => {
  const counts = countBySeverity(findings);
  const totalActive = Object.values(counts).reduce((a, b) => a + b, 0);
  const resolvedPct = calculateResolvedPercentage(findings);
  const mostRecent = getMostRecentFindingDate(findings);

  return (
    <Card>
      <CardHeader title="Resumo de Vulnerabilidades" />
      <CardContent>
        <Grid container spacing={2}>
          {SEVERITY_ORDER.map(sev => (
            <Grid item key={sev}>
              <Chip
                label={`${sev}: ${counts[sev]}`}
                style={{
                  backgroundColor: getSeverityColor(sev),
                  color: '#fff',
                  fontWeight: 600,
                }}
              />
            </Grid>
          ))}
        </Grid>
        <Grid container spacing={2} style={{ marginTop: 16 }}>
          <Grid item xs={4}>
            <Typography variant="subtitle2" color="textSecondary">
              Total Ativos
            </Typography>
            <Typography variant="h5">{totalActive}</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="subtitle2" color="textSecondary">
              Resolvidos
            </Typography>
            <Typography variant="h5">{resolvedPct}%</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="subtitle2" color="textSecondary">
              Finding Mais Recente
            </Typography>
            <Typography variant="h5">
              {mostRecent ?? 'N/A'}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
